/*
    OneDrawer 1.0.0 Usage
    Yang @onerockwell
    
    var drawerCtl = OneDrawer.init({
        el: self.$body,                 // Make sure this scope covers all your trigger element and the Drawer, usually we use body
        drawerElem: '#drawer',          // Your drawer class or id
        triggerEvent: 'click',          // Trigger event
        triggerElem: '.drawer-toggle',  // Your drawer trigger id 
        openCallback: function(){ alert('opened!'); }        // You can add drawer open callback function here
        events: {                       // Accept events key pairs 
            'click form button' : function(e){
                e.preventDefault();
                var $form = $(e.currentTarget).parent('form');
                if ($form.find('input').val()) {
                    // Note: 'this' represent the OneDrawer object not the current view, coloseDrawer() is an native member function of OneDrawer
                    this.closeDrawer(); 
                    $form.submit();
                }
            }
        }
    });
*/

import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

"use strict";

var OneDrawerView = Backbone.View.extend({
		
    initialize: function (settings) {
        var self = this;
        
        self.drawerElem = settings.drawerElem;
        self.triggerEvent = settings.triggerEvent;
        self.triggerElem = settings.triggerElem;
        self.openCallback = settings.openCallback ? settings.openCallback : function(){ console.log('open call back') };
        self.eventsAdditional = settings.events ? settings.events : {};
        
        self.$body = self.$el;
        self.$drawer = $(self.drawerElem);
        self.events = {};
        
        // Global events
        $(document).on(self.triggerEvent + ' keyup', function (e) {
            if ( e.type == self.triggerEvent || (e.type == 'keyup' && e.keyCode == 27) ) {
                self.closeDrawer();
            }
        });
        
        // Trigger event
        var eventKey = self.triggerEvent + ' ' + self.triggerElem;
        self.events[eventKey] = function(e) {
            e.stopPropagation();
            e.preventDefault();
            self.openCallback();
            console.log('[DRAWER] Toggle:', self.$drawer);
            if(self.triggerElem.indexOf('.menu-toggle')> -1 ){
                self.drawerCtl(false,'menu');
            }else{
                self.drawerCtl(false);
            }
        };
        
        // Drawer event
        var eventKey = self.triggerEvent + ' ' + self.drawerElem;
        self.events[eventKey] = function(e) {
            e.stopPropagation();
        };
        var eventKey = self.triggerEvent + ' ' + self.drawerElem + ' .drawer-close';
        self.events[eventKey] = function(e) {
            e.stopPropagation();
            e.preventDefault();
            self.closeDrawer();
        };
        
        _.extend(self.events, self.eventsAdditional);
        self.delegateEvents();
        // console.log(self.events);
    },

    events: {
        // Using dynamic event trigger to make the module configurable
    },
    
    drawerCtl: function(forceClose,theOpenedDrawer){
        var self = this;
        if (forceClose) {
            self.$body.removeClass('show-overlay drawer-opt menu-opened');
            self.$drawer.removeClass('opened');
        } else {
            self.$body.trigger('drawer-opt');

            $('.'+self.commonDrawerClass).not(self.$drawer).each(function(i,e){
                $(e).removeClass('opened');
            });

            self.$drawer.toggleClass('opened');
            if(typeof theOpenedDrawer !== 'undefined' > 0){
                self.$body.toggleClass(theOpenedDrawer+'-opened');
            }else{
                self.$body.removeClass(theOpenedDrawer+'-opened');
            }
        }
    },
    
    openDrawer: function() {
        var self = this;

        self.closev2Drawers();

        self.$body.trigger('drawer-opt');
        self.$drawer.addClass('opened');
    },
    
    closeDrawer: function() {
        var self = this;
        // console.log('Close drawer');
        self.$body.trigger('drawer-closing');
        self.drawerCtl(true);
    },

    closev2Drawers: function() {
        var self = this;
        // This is a cleanup function to clear all the v2 drawers
        // All v2 drawers are stored on ORW.drawerStack
        // Implemented to aviod clashing
        _.each(ORW.drawerStack, function(drawer) {
            if (drawer.drawerOpened) {
                drawer.closeDrawer(true);
            }
        });
    },
    
    destroy: function() {
        var self = this;
        self.undelegateEvents();
    }

});

var OneDrawer = {
    init: function (settings) {
        return new OneDrawerView(settings);
    }
}

export default OneDrawer;